import React from "react";
import { connect } from "react-redux";
import "./index.css";
import { bindActionCreators } from "redux";
import { withTranslation } from "react-i18next";
import Container from "@material-ui/core/Container";

import review_ua_1 from "./../../resources/img/reviews/ua/review_1.png";
import review_ua_2 from "./../../resources/img/reviews/ua/review_2.png";
import review_ua_3 from "./../../resources/img/reviews/ua/review_3.png";
import review_ua_4 from "./../../resources/img/reviews/ua/review_4.png";

import review_by_1 from "./../../resources/img/reviews/by/review_1.jpg";
import review_by_2 from "./../../resources/img/reviews/by/review_2.jpg";
import review_by_3 from "./../../resources/img/reviews/by/review_3.jpg";
import review_by_4 from "./../../resources/img/reviews/by/review_4.jpg";

import review_ru_1 from "./../../resources/img/reviews/ru/review_1.jpg";
import review_ru_2 from "./../../resources/img/reviews/ru/review_2.jpg";
import review_ru_3 from "./../../resources/img/reviews/ru/review_3.jpg";
import review_ru_4 from "./../../resources/img/reviews/ru/review_4.jpg";

import Grid from "@material-ui/core/Grid";

class ReviewsComponent extends React.Component {
  render() {
    const { t } = this.props;
    let domain = window.location.hostname.split(".")[
      window.location.hostname.split(".").length - 1
    ];
    // domain = "by";
    const reviewsSchema = {
      ua: [review_ua_1, review_ua_2, review_ua_3, review_ua_4],
      by: [review_by_1, review_by_2, review_by_3, review_by_4],
      ru: [review_ru_1, review_ru_2, review_ru_3, review_ru_4],
    };
    let array = reviewsSchema[domain]
      ? reviewsSchema[domain]
      : reviewsSchema["ua"];
    return (
      <>
        <section className="reviews" id="reviews">
          <Container fixed>
            <Grid container>
              <Grid item md={12}>
                <h2>{t("reviews.title")}</h2>
              </Grid>
              {array.map((el, index) => {
                return (
                  <Grid item md={6} key={index}>
                    <img
                      alt=""
                      src={el}
                      className={domain === "ua" ? "no-shadow" : ""}
                    />
                  </Grid>
                );
              })}
            </Grid>
          </Container>
        </section>
      </>
    );
  }
}

const widthConnect = connect(
  (state) => ({}),
  (dispatch) => bindActionCreators({}, dispatch)
);

export default withTranslation()(widthConnect(ReviewsComponent));
